<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="医生ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorId', validatorRules.doctorId]" placeholder="请输入医生ID" disabled></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医生余额(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['balance', validatorRules.balance]" placeholder="请输入医生余额(元)" disabled style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="累计收入（元）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['totalAmount', validatorRules.totalAmount]" placeholder="请输入累计收入（元）" disabled style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开户行信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['bankName']" placeholder="请输入开户行信息" disabled></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['accountName']" placeholder="请输入开户名" disabled></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="卡号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['accountNo']" placeholder="请输入卡号" disabled></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="agreementUrl" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['agreementUrl']" placeholder="请输入agreementUrl" disabled></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="银行预留手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['reservedPhone', validatorRules.reservedPhone]" placeholder="请输入银行预留手机号" disabled></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@comp/jeecg/JFormContainer'

  export default {
    name: 'DoctorAccountForm',
    components: {
      JFormContainer,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
        doctorId: {
        rules: [
            { required: true, message: '请输入医生ID!'},
        ]
        },
        balance: {
        rules: [
            { required: true, message: '请输入医生余额(元)!'},
        ]
        },
        totalAmount: {
        rules: [
            { required: true, message: '请输入累计收入（元）!'},
        ]
        },
        reservedPhone: {
        rules: [
            { required: true, message: '请输入银行预留手机号!'},
        ]
        },
},
        url: {
          add: "/daccount/doctorAccount/add",
          edit: "/daccount/doctorAccount/edit",
          queryById: "/daccount/doctorAccount/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'doctorId','balance','totalAmount','bankName','accountName','accountNo','agreementUrl','reservedPhone'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'doctorId','balance','totalAmount','bankName','accountName','accountNo','agreementUrl','reservedPhone'))
      },
    }
  }
</script>